module.exports = __webpack_public_path__ + "img/documentation-icon.69933cd4.svg";